(() => {

  'use strict';

  function initMangoalGiftCenter(root) {
if (
    !root ||
    root.dataset.bound === 'true'
  ) {
    return;
  }


  root.dataset.bound =
    'true';



  /* ==========================================================
     ELEMENTS
  ========================================================== */

  const wheel =
    root.querySelector(
      '[data-wheel]'
    );


  const labels = [
    ...root.querySelectorAll(
      '[data-prize-id]'
    )
  ];


  const form =
    root.querySelector(
      '[data-form]'
    );


  const button =
    root.querySelector(
      '[data-submit]'
    );


  const buttonText =
    root.querySelector(
      '[data-button-text]'
    );


  const spinner =
    root.querySelector(
      '[data-spinner]'
    );


  const message =
    root.querySelector(
      '[data-message]'
    );



  /* ==========================================================
     ENTRY MODAL
  ========================================================== */

  const entryModal =
    root.querySelector(
      '[data-entry-modal]'
    );


  const entryOpen =
    root.querySelector(
      '[data-open-entry]'
    );


  const entryClose =
    root.querySelector(
      '[data-entry-close]'
    );



  /* ==========================================================
     INFO MODAL
  ========================================================== */

  const infoModal =
    root.querySelector(
      '[data-info-modal]'
    );


  const infoClose =
    root.querySelector(
      '[data-info-close]'
    );


  const infoButtons = [
    ...root.querySelectorAll(
      '[data-info-open]'
    )
  ];


  const infoPanels = [
    ...root.querySelectorAll(
      '[data-info-panel]'
    )
  ];



  /* ==========================================================
     RESULT MODAL
  ========================================================== */

  const resultModal =
    root.querySelector(
      '[data-modal]'
    );


  const resultModalClose =
    root.querySelector(
      '[data-modal-close]'
    );


  const resultTitle =
    root.querySelector(
      '[data-result-title]'
    );


  const resultText =
    root.querySelector(
      '[data-result-text]'
    );


  const spinIdEl =
    root.querySelector(
      '[data-spin-id]'
    );


  const couponResult =
    root.querySelector(
      '[data-coupon-result]'
    );


  const couponCodeEl =
    root.querySelector(
      '[data-coupon-code]'
    );


  const reviewResult =
    root.querySelector(
      '[data-review-result]'
    );



  /* ==========================================================
     CONFIG
  ========================================================== */

  const endpoint =
    '/apps/drive-win/spin';


  const defaultButton =
    root.dataset.buttonLabel ||
    'Verify Order & Spin';


  const loadingLabel =
    root.dataset.loadingLabel ||
    'Verifying your order…';


  const spinningLabel =
    root.dataset.spinningLabel ||
    'Unlocking your reward…';


  const defaultResultHeading =
    root.dataset.resultHeading ||
    'Reward unlocked!';


  const defaultResultText =
    root.dataset.resultText ||
    'Your reward has been recorded.';


  const SPIN_DURATION =
    4200;


  let currentRotation =
    0;


  let isSpinning =
    false;


  let resultTimer =
    null;



  /* ==========================================================
     USER-FACING ERROR MESSAGES
  ========================================================== */

  const errorMessages = {

    campaign_disabled:
      'MANGOAL Order Rewards are not currently available.',

    campaign_not_started:
      'MANGOAL Order Rewards have not started yet.',

    campaign_ended:
      'This MANGOAL Order Rewards event has ended. Thank you for shopping with MANGOAL.',

    order_not_found:
      'We couldn’t verify this order. Please check your order number and the email used at checkout.',

    email_mismatch:
      'We couldn’t verify this order. Please check your order number and the email used at checkout.',

    order_not_paid:
      'This order is not currently eligible for MANGOAL Order Rewards.',

    order_cancelled:
      'Cancelled orders are not eligible for MANGOAL Order Rewards.',

    test_order:
      'Test orders are not eligible for MANGOAL Order Rewards.',

    order_outside_campaign:
      'This order was placed outside the eligible reward period.',

    already_used:
      'The reward for this order has already been claimed.',

    missing_input:
      'Please enter your order number and the email used at checkout.',

    prize_not_found:
      'Reward configuration mismatch. Please contact MANGOAL Support.',

    discount_create_failed:
      'Your coupon reward was selected, but the coupon code could not be created right now. Please contact MANGOAL Support.',

    shopify_error:
      'We’re unable to verify your order right now. Please try again later.'

  };



  /* ==========================================================
     BODY SCROLL LOCK
  ========================================================== */

  const lockPage = () => {

    document.documentElement.style.overflow =
      'hidden';

    document.body.style.overflow =
      'hidden';

  };


  const unlockPage = () => {

    const modals = [
      entryModal,
      infoModal,
      resultModal
    ];


    const anyOpen =
      modals.some(
        (modal) =>
          modal &&
          !modal.hidden
      );


    if (
      !anyOpen
    ) {

      document.documentElement.style.overflow =
        '';

      document.body.style.overflow =
        '';

    }

  };



  /* ==========================================================
     ENTRY MODAL
  ========================================================== */

  const openEntryModal = () => {

    if (
      !entryModal ||
      isSpinning
    ) {
      return;
    }


    entryModal.hidden =
      false;


    lockPage();


    window.setTimeout(
      () => {

        const firstInput =
          entryModal.querySelector(
            'input[name="order_number"]'
          );


        if (
          firstInput
        ) {
          firstInput.focus();
        }

      },
      60
    );

  };


  const closeEntryModal = () => {

    if (
      !entryModal ||
      isSpinning
    ) {
      return;
    }


    entryModal.hidden =
      true;


    unlockPage();

  };



  /* ==========================================================
     INFO MODAL
  ========================================================== */

  const openInfoModal = (
    type
  ) => {

    if (
      !infoModal
    ) {
      return;
    }


    infoPanels.forEach(
      (
        panel
      ) => {

        panel.hidden =
          panel.dataset.infoPanel !==
          type;

      }
    );


    infoModal.hidden =
      false;


    lockPage();


    const visiblePanel =
      infoPanels.find(
        (
          panel
        ) =>
          !panel.hidden
      );


    if (
      visiblePanel
    ) {

      const card =
        infoModal.querySelector(
          '.mgo-gift__modal-card'
        );


      if (
        card
      ) {
        card.scrollTop =
          0;
      }

    }

  };


  const closeInfoModal = () => {

    if (
      !infoModal
    ) {
      return;
    }


    infoModal.hidden =
      true;


    unlockPage();

  };



  /* ==========================================================
     RESULT MODAL
  ========================================================== */

  const closeResultModal = () => {

    if (
      !resultModal
    ) {
      return;
    }


    resultModal.hidden =
      true;


    unlockPage();

  };



  /* ==========================================================
     LOADING STATE
  ========================================================== */

  const setLoading = (
    loading
  ) => {

    if (
      !button ||
      !spinner ||
      !buttonText
    ) {
      return;
    }


    button.disabled =
      loading;


    spinner.hidden =
      !loading;


    buttonText.textContent =
      loading
        ? loadingLabel
        : defaultButton;

  };



  /* ==========================================================
     FIND PRIZE INDEX
  ========================================================== */

  const findPrizeIndex = (
    prizeId
  ) => {

    const target =
      String(
        prizeId ||
        ''
      ).trim();


    if (
      !target
    ) {
      return -1;
    }


    return labels.findIndex(
      (
        element
      ) =>

        String(
          element.dataset.prizeId ||
          ''
        ).trim() ===
        target

    );

  };



  /* ==========================================================
     SPIN WHEEL
  ========================================================== */

  const spinTo = (
    index
  ) => {

    const count =
      Math.max(
        labels.length,
        1
      );


    const segment =
      360 /
      count;


    /*
      CSS wheel:
      first segment occupies 0-60 degrees.

      Pointer:
      0 degrees / top.

      We rotate so the selected segment center
      ends at the pointer.
    */

    const centerAngle =
      index *
      segment +
      segment / 2;


    const desiredNormalized =
      (
        360 -
        centerAngle
      ) %
      360;


    const currentNormalized =
      (
        (
          currentRotation %
          360
        ) +
        360
      ) %
      360;


    let delta =
      (
        desiredNormalized -
        currentNormalized +
        360
      ) %
      360;


    /*
      6 full rotations
    */

    delta +=
      6 *
      360;


    currentRotation +=
      delta;


    wheel.style.transform =
      `rotate(${currentRotation}deg)`;

  };



  /* ==========================================================
     MANUAL REVIEW CHECK
  ========================================================== */

  const requiresManualReview = (
    prize
  ) => {

    const id =
      String(
        prize?.id ||
        ''
      ).toLowerCase();


    const type =
      String(
        prize?.type ||
        ''
      ).toLowerCase();


    return (

      id ===
        'free_order' ||

      id ===
        'cashback_10' ||

      id ===
        'cashback_5' ||

      id ===
        'cashback_1' ||

      id ===
        'mangoal_mug' ||

      type ===
        'refund' ||

      type ===
        'cashback' ||

      type ===
        'physical'

    );

  };



  /* ==========================================================
     RESULT COPY
  ========================================================== */

  const getRewardMessage = (
    prize
  ) => {

    const id =
      String(
        prize?.id ||
        ''
      ).toLowerCase();


    const type =
      String(
        prize?.type ||
        ''
      ).toLowerCase();


    const value =
      Number(
        prize?.value ||
        0
      );



    /*
      WIN YOUR ORDER BACK
    */

    if (
      id ===
        'free_order' ||
      type ===
        'refund'
    ) {

      return (
        'Congratulations! You unlocked a chance to Win Your Order Back, up to $300. ' +
        'This reward is subject to manual review and order verification. ' +
        'Our team will review your eligibility and send the final reward details to the email associated with your order.'
      );

    }



    /*
      CASHBACK
    */

    if (
      type ===
        'cashback' ||
      id ===
        'cashback_10' ||
      id ===
        'cashback_5' ||
      id ===
        'cashback_1'
    ) {

      return (
        `Congratulations! You unlocked a $${value} Cashback reward. ` +
        'This reward is subject to manual review and order verification. ' +
        'Our team will review your eligibility and send the fulfillment details to the email associated with your order.'
      );

    }



    /*
      PHYSICAL GIFT
    */

    if (
      type ===
        'physical' ||
      id ===
        'mangoal_mug'
    ) {

      return (
        'Congratulations! You unlocked a MANGOAL Mug. ' +
        'This reward is subject to manual review and fulfillment confirmation. ' +
        'Our team will contact you using the email associated with your order after verification.'
      );

    }



    /*
      COUPON
    */

    if (
      type ===
        'coupon' ||
      id ===
        'coupon_10'
    ) {

      const couponCode =
        String(
          prize?.coupon_code ||
          ''
        ).trim();


      if (
        couponCode
      ) {

        return (
          `Congratulations! You unlocked ${value}% OFF your next MANGOAL order. ` +
          'Your unique coupon code is ready to use and has also been sent to the email associated with your order.'
        );

      }


      return (
        `Congratulations! You unlocked ${value}% OFF your next MANGOAL order. ` +
        'Your coupon details will be sent to the email associated with your order.'
      );

    }


    return (
      defaultResultText
    );

  };



  /* ==========================================================
     SHOW RESULT
  ========================================================== */

  const showResult = (
    payload
  ) => {

    if (
      !resultModal
    ) {
      return;
    }


    const prize =
      payload.prize ||
      {};


    const manualReview =
      requiresManualReview(
        prize
      );



    /*
      TITLE
    */

    if (
      resultTitle
    ) {

      resultTitle.textContent =
        prize.name ||
        defaultResultHeading;

    }



    /*
      DESCRIPTION
    */

    if (
      resultText
    ) {

      resultText.textContent =
        getRewardMessage(
          prize
        );

    }



    /*
      MANUAL REVIEW BOX
    */

    if (
      reviewResult
    ) {

      reviewResult.hidden =
        !manualReview;

    }



    /*
      COUPON
    */

    if (
      couponResult &&
      couponCodeEl
    ) {

      const couponCode =
        String(
          prize.coupon_code ||
          ''
        ).trim();


      if (
        !manualReview &&
        couponCode
      ) {

        couponCodeEl.textContent =
          couponCode;


        couponResult.hidden =
          false;

      } else {

        couponCodeEl.textContent =
          '';


        couponResult.hidden =
          true;

      }

    }



    /*
      REWARD ID
    */

    if (
      spinIdEl
    ) {

      spinIdEl.textContent =
        payload.spinId
          ? 'Reward ID: ' +
            payload.spinId
          : '';

    }



    /*
      OPEN MODAL
    */

    resultModal.hidden =
      false;


    lockPage();


    if (
      resultModalClose
    ) {

      window.setTimeout(
        () => {

          resultModalClose.focus();

        },
        50
      );

    }

  };



  /* ==========================================================
     FORM SUBMIT
  ========================================================== */

  if (
    form
  ) {

    form.addEventListener(
      'submit',
      async (
        event
      ) => {

        event.preventDefault();



        if (
          isSpinning
        ) {
          return;
        }



        if (
          !form.reportValidity()
        ) {
          return;
        }



        const orderNumber =
          form.elements
            .order_number
            .value
            .trim();


        const email =
          form.elements
            .email
            .value
            .trim();



        if (
          resultTimer
        ) {

          window.clearTimeout(
            resultTimer
          );


          resultTimer =
            null;

        }



        setLoading(
          true
        );


        if (
          message
        ) {
          message.textContent =
            '';
        }



        try {

          const response =
            await fetch(
              endpoint,
              {

                method:
                  'POST',

                headers: {

                  'Content-Type':
                    'application/json'

                },

                body:
                  JSON.stringify(
                    {
                      orderNumber,
                      email
                    }
                  )

              }
            );



          const payload =
            await response
              .json()
              .catch(
                () => ({})
              );



          if (
            !response.ok ||
            !payload.ok
          ) {

            throw new Error(

              errorMessages[
                payload.code
              ] ||

              payload.message ||

              'We’re unable to verify your order right now. Please try again later.'

            );

          }



          /*
            MATCH WORKER RESULT TO WHEEL
          */

          const prizeId =
            payload.prize &&
            payload.prize.id;


          const index =
            findPrizeIndex(
              prizeId
            );


          if (
            index <
            0
          ) {

            console.error(
              '[MANGOAL Order Rewards] Reward ID returned by Worker does not exist on wheel:',
              prizeId
            );


            throw new Error(
              errorMessages
                .prize_not_found
            );

          }



          /*
            START SPIN
          */

          isSpinning =
            true;


          if (
            message
          ) {

            message.textContent =
              spinningLabel;

          }


          if (
            button
          ) {
            button.disabled =
              true;
          }


          if (
            spinner
          ) {
            spinner.hidden =
              true;
          }


          if (
            buttonText
          ) {

            buttonText.textContent =
              spinningLabel;

          }



          /*
            CLOSE ENTRY MODAL
          */

          if (
            entryModal &&
            !entryModal.hidden
          ) {

            entryModal.hidden =
              true;

          }


          document.documentElement.style.overflow =
            '';

          document.body.style.overflow =
            '';



          /*
            SCROLL TO WHEEL
          */

          const wheelArea =
            root.querySelector(
              '.mgo-gift__wheel-area'
            );


          if (
            wheelArea
          ) {

            window.setTimeout(
              () => {

                wheelArea.scrollIntoView(
                  {
                    behavior:
                      'smooth',

                    block:
                      'center'
                  }
                );

              },
              80
            );

          }



          /*
            SPIN
          */

          window.setTimeout(
            () => {

              spinTo(
                index
              );

            },
            250
          );



          /*
            SHOW RESULT AFTER SPIN
          */

          resultTimer =
            window.setTimeout(
              () => {

                showResult(
                  payload
                );


                if (
                  message
                ) {
                  message.textContent =
                    '';
                }


                isSpinning =
                  false;


                setLoading(
                  false
                );


                resultTimer =
                  null;

              },

              SPIN_DURATION +
              500
            );



        } catch (
          error
        ) {

          isSpinning =
            false;


          setLoading(
            false
          );


          if (
            message
          ) {

            message.textContent =
              error.message ||
              'Something went wrong while unlocking your reward. Please try again later.';

          }

        }

      }
    );

  }



  /* ==========================================================
     ENTRY EVENTS
  ========================================================== */

  if (
    entryOpen
  ) {

    entryOpen.addEventListener(
      'click',
      openEntryModal
    );

  }


  if (
    entryClose
  ) {

    entryClose.addEventListener(
      'click',
      closeEntryModal
    );

  }


  if (
    entryModal
  ) {

    entryModal.addEventListener(
      'click',
      (
        event
      ) => {

        if (
          event.target ===
          entryModal
        ) {

          closeEntryModal();

        }

      }
    );

  }



  /* ==========================================================
     INFO EVENTS
  ========================================================== */

  infoButtons.forEach(
    (
      button
    ) => {

      button.addEventListener(
        'click',
        () => {

          openInfoModal(
            button.dataset.infoOpen
          );

        }
      );

    }
  );


  if (
    infoClose
  ) {

    infoClose.addEventListener(
      'click',
      closeInfoModal
    );

  }


  if (
    infoModal
  ) {

    infoModal.addEventListener(
      'click',
      (
        event
      ) => {

        if (
          event.target ===
          infoModal
        ) {

          closeInfoModal();

        }

      }
    );

  }



  /* ==========================================================
     RESULT EVENTS
  ========================================================== */

  if (
    resultModalClose
  ) {

    resultModalClose.addEventListener(
      'click',
      closeResultModal
    );

  }


  if (
    resultModal
  ) {

    resultModal.addEventListener(
      'click',
      (
        event
      ) => {

        if (
          event.target ===
          resultModal
        ) {

          closeResultModal();

        }

      }
    );

  }



  /* ==========================================================
     ESCAPE KEY
  ========================================================== */

  document.addEventListener(
    'keydown',
    (
      event
    ) => {

      if (
        event.key !==
        'Escape'
      ) {
        return;
      }



      /*
        RESULT PRIORITY
      */

      if (
        resultModal &&
        !resultModal.hidden
      ) {

        closeResultModal();

        return;

      }



      /*
        ENTRY
      */

      if (
        entryModal &&
        !entryModal.hidden &&
        !isSpinning
      ) {

        closeEntryModal();

        return;

      }



      /*
        INFO
      */

      if (
        infoModal &&
        !infoModal.hidden
      ) {

        closeInfoModal();

      }

    }
  );

  }


  function initMangoalGiftCenters(scope) {

    const roots =
      scope.matches &&
      scope.matches('[data-mgo-gift-center]')
        ? [scope]
        : [
            ...scope.querySelectorAll(
              '[data-mgo-gift-center]'
            )
          ];


    roots.forEach(
      initMangoalGiftCenter
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => initMangoalGiftCenters(document),
      { once: true }
    );

  } else {

    initMangoalGiftCenters(document);

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => initMangoalGiftCenters(event.target)
  );

})();



